import { DbService } from 'generated-common/mock-data/internal/db-service';
import { SeedService } from 'generated-common/mock-data/internal/seed-service';
import {
  CodeclouMockedApi,
  CodeclouLocalStorage,
  mockedStorageStartsWith,
  CustomStorageService,
  CustomBackendResolver,
  mockedResolver,
  mockedRoute,
  mockedPermissionEditorModuleContext_ADMIN,
  mockedFieldEditorModuleContext_USER,
} from '../generated-common';
import { CreateHistoryFunctionPayload, HistoryAction, HistoryLocationDescriptor, HistoryUnlistenCallback, ViewMock } from './frontend-mock-forge-bridge-model';
import { match } from 'path-to-regexp';
import { createBrowserHistory, Update } from 'history';
import { MOCKED_LICENSE_SERVICE_VALID } from 'generated-common/mock-data/mocked-for-tests';

const dbService = new DbService();
const codeclouLocalStorage = new CodeclouLocalStorage(dbService);
const customStorageService = new CustomStorageService(codeclouLocalStorage, mockedStorageStartsWith);
const seedService = new SeedService(dbService, customStorageService);
seedService.doSeed();

export const invokeMock = () => {
  // import in mocked frontend
  const invoke = (key: string, params?: any) => {
    // default = USER
    let testId = 'TESTID_MIA';
    let mockedContext: any = mockedFieldEditorModuleContext_USER;
    // console.log('ENV', process.env.REACT_APP_USER);
    if (process && process.env && process.env.REACT_APP_USER === 'admin') {
      testId = 'TESTID_ADMIN';
      mockedContext = mockedPermissionEditorModuleContext_ADMIN;
    }
    // NOTE: Switch here to MOCKED_LICENSE_SERVICE_INVALID to test invalid license condition
    const licenseService = new MOCKED_LICENSE_SERVICE_VALID();
    const customResolver = new CustomBackendResolver(mockedResolver, new CodeclouMockedApi(match, testId, dbService, null), mockedRoute, customStorageService, licenseService);
    return customResolver.invoke(key, params, mockedContext);
  };
  return { invoke: invoke };
};

export const viewMock: ViewMock = {
  // NOTE: WE ONLY NEED THIS IN LOCAL DEV MODE WHERE NO FORGE VIEW IS AVAILABLE!

  theme: {
    enable: () => {
      return Promise.resolve();
    },
  },
  createHistory: () => {
    // We use 'createBrowserHistory' from history package to inject into React-Router
    // We need this since we use this guide to make react-router and forge work together:
    // https://developer.atlassian.com/platform/forge/add-routing-to-a-full-page-app/
    const internalHistory = createBrowserHistory();
    const mockedViewPayload = {
      action: 'POP',
      location: {
        pathname: internalHistory.location.pathname,
        search: internalHistory.location.search,
        hash: internalHistory.location.hash,
        state: internalHistory.location.state,
      } as HistoryLocationDescriptor,
      push: (location: HistoryLocationDescriptor) => {
        internalHistory.push(location);
      },
      replace: (location: HistoryLocationDescriptor) => {
        internalHistory.replace(location);
      },
      go: (n: number) => {
        internalHistory.go(n);
      },
      goBack: () => {
        internalHistory.back();
      },
      goForward: () => {
        internalHistory.forward();
      },
      listen: (listener: (location: HistoryLocationDescriptor, action: HistoryAction) => void): HistoryUnlistenCallback => {
        internalHistory.listen((update: Update) => {
          listener(update.location, update.action);
        });
        return () => {};
      },
    } as CreateHistoryFunctionPayload;
    return Promise.resolve(mockedViewPayload);
  },
};

export const routerOpenMock = (str: string): Promise<void> => {
  window.open(str);
  return Promise.resolve();
};
